<section class="container py-5 mt-5 mb-sm-2 mb-lg-3 mb-xl-4 mb-xxl-5">
  <h2 class="h1">{{event?.name}}</h2>
  <div class="row pb-sm-1 pb-md-4">
    <div class="col-lg-8 mb-3 mb-md-0">

      <!-- Event details -->
      <section *ngIf="event" class="card bg-secondary border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
        <div class="position-relative">
          <span [ngClass]="event?.isPublic ? 'bg-info' : 'bg-warning'"
            class="badge position-absolute start-0 bottom-0 mb-3 ms-3">{{event?.isPublic
            ? 'Public' : 'Privat'}}</span>
          <img [src]="event.image" [alt]="event.name" class="card-img">
        </div>

        <div class="card-body">
          <div class="d-flex align-items-center mt-sm-n1 pb-4 mb-0 mb-lg-1 mb-xl-3">
            <div *ngIf="event?.recipientName" class="d-flex align-items-center">
              <img class="rounded-circle object-fit-cover" [src]="event.recipientImage" style="width:48px;height:48px;" [alt]="event?.recipientName">
              <div class="ps-3">
                <span class="fs-sm text-muted">Pentru</span>
                <h6 class="mb-0">{{event?.recipientName}}</h6>
              </div>
            </div>
            <a *ngIf="isEventOwner" [routerLink]="['/user/creare-eveniment', eventCode]" class="btn btn-sm btn-secondary ms-auto"><i
                class="ai-edit ms-n1 me-2"></i>Modifica</a>
          </div>
          <div [innerHTML]="event.description | safe: 'html'" class="card-text"></div>
        </div>
      </section>

      <!-- Loading template -->
      <section *ngIf="!event" class="card bg-secondary border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4" aria-hidden="true">
        <div class="position-relative placeholder-glow">
          <div class="card-img placeholder ratio ratio-16x9"></div>
          <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
        </div>
        <div class="card-body">
          <h5 class="card-title placeholder-glow d-flex justify-content-between">
            <span class="placeholder col-6"></span>
            <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-3"></a>
          </h5>
          <p class="card-text placeholder-glow">
            <span class="placeholder placeholder-sm col-7 me-2"></span>
            <span class="placeholder placeholder-sm col-4"></span>
            <span class="placeholder placeholder-sm col-4 me-2"></span>
            <span class="placeholder placeholder-sm col-6"></span>
            <span class="placeholder placeholder-sm col-12"></span>
          </p>
        </div>
      </section>

      <section class="card bg-secondary d-lg-none border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
        <div class="card-body">
          <ng-container *ngTemplateOutlet="sidebar"></ng-container>
        </div>
      </section>


      <!-- Updates -->
      <gs-event-updates *ngIf="isEventOwner || event?.updates?.length > 0" [eventId]="event?.id" [updates]="event?.updates"
        [eventUserId]="event?.userId">
      </gs-event-updates>

      <!-- Comments -->
      <gs-event-comments *ngIf="hasCommentsEnabled && !event?.hasCommentsHidden" [eventId]="event?.id" [eventUserId]="event?.id" [comments]="event?.comments">
      </gs-event-comments>


    </div>

    <!-- Product details-->
    <div class="col-lg-4 ">


      <div class="d-none d-md-block" style="margin-top: -90px;"></div>
      <div class="position-md-sticky top-0">
        <div class="d-none d-md-block" style="padding-top: 90px;"></div>

        <aside class="card bg-secondary d-none d-lg-flex border-0 mb-4">
          <div class="card-body">

            <ng-container *ngTemplateOutlet="sidebar"></ng-container>

            <ng-template #sidebar>

              <ng-container *ngIf="event">

                <!-- Suspended notice-->
                <div *ngIf="event.isSuspended && isEventOwner" class="alert alert-danger" role="alert">
                  <h4 class="pt-2 alert-heading"><i class="ai-circle-slash fs-xl pe-1 me-2"></i>Eveniment suspendat</h4>
                  <hr class="text-info opacity-25 mb-3">
                  <p>Evenimentul a fost suspendat de catre administrator.</p>
                  <hr class="text-danger opacity-25 mb-3">
                  <p class="mb-2"><span class="fw-semibold">Motiv:</span> {{event.suspendReason}}
                  </p>
                </div>

                <!-- Action buttons-->
                <div class="d-sm-flex d-md-block d-lg-flex">
                  <a [routerLink]="['/contributie', eventCode]"
                    [class.disabled]="!event.isStarted || event.status !== 'Active' || !hasContributionsEnabled || event.isSuspended || (isCorporateUser$ | async)"
                    class="btn btn-lg btn-primary w-100" type="button"><i class="ai-card me-2 ms-n1"></i>Contribuie</a>
                </div>

                <div *ngIf="!event.hasTargetAmountHidden"
                  class="d-flex flex-column bg-faded-primary rounded-3 text-center p-4 mt-4">
                  <div class="h4 display-6 mt-2 mb-0">{{event.totalContributionAmount | number: '1.0-0'}} <span
                      class="d-inline-block d-md-none d-lg-inline-block">lei</span></div>
                  <div *ngIf="event.targetAmount" class="fs-lg mb-1">din targetul de <span
                      class="fw-semibold">{{event.targetAmount}}</span> lei</div>
                  <div *ngIf="!event.targetAmount" class="fs-lg mb-1">pana in acest moment</div>
                  <div class="progress mb-1 border border-primary">
                    <div class="progress-bar fw-semibold" role="progressbar" [style.width.%]="event.targetProgress"
                      [attr.aria-valuenow]="event.targetProgress" aria-valuemin="0" aria-valuemax="100">
                      {{event.targetProgress}}%
                    </div>
                  </div>
                  <div *ngIf="event.status==='Active'" class="fs-lg">Se incheie la <span class="fw-semibold">{{event.deadlineDate |
                      date:
                      'dd/MM/yyyy'}}</span>
                  </div>
                  <div *ngIf="event.status==='Completed'" class="fs-lg">Incheiat la <span
                      class="fw-semibold text-danger">{{event.deadlineDate | date:
                      'dd/MM/yyyy'}}</span>
                  </div>
                </div>

                <div class="d-flex align-items-center mt-4">
                  <img class="rounded-circle object-fit-cover" [src]="event.userImage" style="width:48px;height:48px;" [alt]="event?.userName">
                  <div class="ps-3">
                    <span class="fs-sm text-muted">Creat de</span>
                    <h6 class="mb-0">{{event?.userName}}</h6>
                  </div>
                </div>

                <div class="d-flex flex-wrap align-items-center mt-4">

                  <ng-container *ngIf="isEventOwner && event.status==='Active'">
                    <button [routerLink]="['/user/creare-eveniment', eventCode]" ngbTooltip="Modifica evenimentul"
                      type="button" class="btn btn-outline-primary btn-icon me-2 mb-2">
                      <i class="ai-edit-alt"></i>
                    </button>
                    <button [routerLink]="['/user/invitatii', eventCode]" ngbTooltip="Invita-ti prietenii" type="button"
                      class="btn btn-outline-primary btn-icon me-2 mb-2">
                      <i class="ai-user-plus"></i>
                    </button>
                    <button (click)="onPauseClick(eventCode)"
                      [ngbTooltip]="(event.isStarted ? 'Intrerupe evenimentul temporar' : 'Reporneste eveniment')" type="button"
                      class="btn btn-outline-primary btn-icon me-2 mb-2">
                      <i *ngIf="event.isStarted" class="ai-pause"></i>
                      <i *ngIf="!event.isStarted" class="ai-play"></i>
                    </button>
                    <button (click)="onStop(eventCode)" ngbTooltip="Stop eveniment" type="button"
                      class="btn btn-outline-primary btn-icon me-2 mb-2">
                      <i class="ai-power"></i>
                    </button>

                  </ng-container>

                  <button *ngIf="isEventOwner || !event.hasContributionsHidden" [routerLink]="['/contributii', eventCode]"
                    ngbTooltip="Lista contributii" type="button" class="btn btn-outline-primary btn-icon me-2 mb-2">
                    <i class="ai-chart"></i>
                  </button>

                  <button (click)="onOpenReportModalClick(reportModalTemplate)" ngbTooltip="Raporteaza acest eveniment"
                    type="button" class="btn btn-outline-primary btn-icon me-2 mb-2">
                    <i class="ai-triangle-alert"></i>
                  </button>

                  <button
                    *ngIf="isEventOwner && event.status==='Completed' && event.totalContributionAmount > 0 && event?.recipientName && event.hasCoupon"
                    (click)="onOpenGiftCardModalClick(giftCardModalTemplate)" ngbTooltip="Card GiftShare" type="button"
                    class="btn btn-outline-primary btn-icon me-2 mb-2">
                    <i class="ai-card"></i>
                  </button>

                </div>

                <!-- Invitations -->
                <div *ngIf="isEventOwner" class="d-inline-flex align-items-center mt-4">
                  <h4 class="h6 mb-0 me-4">Invitati:</h4>

                  <div *ngFor="let x of event.invites | slice : 0 : 4; index as index, first as first"
                    [ngClass]="{'ms-n3': !first}"
                    class="bg-light flex-shrink-0 rounded-circle position-relative zindex-{{index + 1}}"
                    style="padding: 3px;">
                    <gs-avatar [name]="x['name']" ngbTooltip="{{x['name']}}" [email]="x['email']"></gs-avatar>
                  </div>
                  <div *ngIf="event.status==='Active'" [routerLink]="['/user/invitatii', eventCode]"
                    [ngClass]="{'ms-n3': event.invites?.length}"
                    class="bg-light flex-shrink-0 rounded-circle position-relative zindex-5" style="padding: 3px;">
                    <button class="btn btn-icon btn-secondary rounded-pill" style="padding: 3px;" type="button"
                      ngbTooltip="Trimite o noua invitatie"><i class="ai-plus fs-xl"></i></button>
                  </div>

                </div>

                <!-- Sharing-->
                <div class="mt-4">
                  <h4 class="h6 me-4">Distribuie:</h4>
                  <gs-social-share [url]="eventUrl"></gs-social-share>
                </div>

              </ng-container>

              <ng-container *ngIf="!event">
                <div class="d-sm-flex d-md-block d-lg-flex mb-3 placeholder-glow">
                  <a href="#" tabindex="-1" class="btn btn-lg rounded-1 btn-primary disabled placeholder col-12"></a>
                </div>
                <h5 class="placeholder-glow">
                  <span class="placeholder col-6"></span>
                </h5>
                <p class="placeholder-glow">
                  <span class="placeholder placeholder-sm col-7 me-2"></span>
                  <span class="placeholder placeholder-sm col-4"></span>
                  <span class="placeholder placeholder-sm col-4 me-2"></span>
                  <span class="placeholder placeholder-sm col-6"></span>
                  <span class="placeholder placeholder-sm col-12"></span>
                  <span class="placeholder placeholder-sm col-6 me-2"></span>
                  <span class="placeholder placeholder-sm col-3"></span>
                  <span class="placeholder placeholder-sm col-12"></span>
                </p>
              </ng-container>
            </ng-template>


          </div>
        </aside>


      </div>
    </div>
  </div>
</section>


<!--Generate Pdf modal-->
<ng-template #giftCardModalTemplate let-modal>
  <div class="modal-header border-0">
    <h4 class="modal-title">Card GiftShare</h4>
    <button (click)="modal?.dismiss()" class="btn-close" type="button" aria-label="Close"></button>
  </div>

  <form [formGroup]="formCoupon" (ngSubmit)="onDownloadPdfSubmit()" class="pt-0" novalidate autocomplete="off">
    <div class="modal-body">
      <div class="row row-cols-1 g-4">
        <div class="col">
          <label class="form-label" for="message">Mesaj personalizat</label>
          <textarea formControlName="message" [ngClass]="{'is-invalid': vs.hasErrors(formCoupon, 'message')}"
            class="form-control" rows="5" placeholder="Adauga un mesaj" id="message" autofocus></textarea>
          <div *ngIf="vs.hasErrors(formCoupon, 'message')" class="invalid-feedback">{{vs.getError(formCoupon,
            'message')}}
          </div>
        </div>

      </div>
    </div>
    <div class="modal-footer border-0">
      <button (click)="modal?.close()" class="btn btn-secondary w-100 w-sm-auto mb-3 mb-sm-0"
        type="button">Anuleaza</button>
      <button class="btn btn-primary w-100 w-sm-auto ms-sm-3" type="submit">Exporta PDF</button>
    </div>
  </form>
</ng-template>


<!--Report event modal-->
<ng-template #reportModalTemplate let-modal>
  <div class="modal-header border-0">
    <h4 class="modal-title">Raporteaza eveniment</h4>
    <button (click)="modal?.dismiss()" class="btn-close" type="button" aria-label="Close"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onReportSubmit()" class="pt-0" novalidate autocomplete="off">
    <div class="modal-body">
      <div class="row row-cols-1 g-4">
        <div class="col">
          <label class="form-label" for="name">Nume</label>
          <input formControlName="name" [ngClass]="{'is-invalid': vs.hasErrors(form, 'name')}" class="form-control"
            type="text" placeholder="" id="name" autofocus>
          <div *ngIf="vs.hasErrors(form, 'name')" class="invalid-feedback">{{vs.getError(form, 'name')}}
          </div>
        </div>
        <div class="col">
          <label class="form-label" for="email">Email</label>
          <input formControlName="email" [ngClass]="{'is-invalid': vs.hasErrors(form, 'email')}" class="form-control"
            type="email" placeholder="" id="email">
          <div *ngIf="vs.hasErrors(form, 'email')" class="invalid-feedback">{{vs.getError(form, 'email')}}
          </div>
        </div>
        <div class="col">
          <label class="form-label" for="causeId">Motivul raportarii</label>
          <select formControlName="causeId" [ngClass]="{'is-invalid': vs.hasErrors(form, 'causeId')}"
            class="form-select" id="causeId">
            <option *ngFor="let data of reportCauses" [ngValue]="data.id">{{data.name}}</option>
          </select>
          <div *ngIf="vs.hasErrors(form, 'causeId')" class="invalid-feedback">{{vs.getError(form, 'causeId')}}
          </div>
        </div>
        <div class="col">
          <label class="form-label" for="reason">Informatii suplimentare</label>
          <textarea formControlName="reason" [ngClass]="{'is-invalid': vs.hasErrors(form, 'reason')}"
            class="form-control" rows="3" placeholder="" id="reason"></textarea>
          <div *ngIf="vs.hasErrors(form, 'reason')" class="invalid-feedback">{{vs.getError(form,
            'reason')}}
          </div>
        </div>

      </div>
    </div>
    <div class="modal-footer border-0">
      <button (click)="modal?.close()" class="btn btn-secondary w-100 w-sm-auto mb-3 mb-sm-0"
        type="button">Anuleaza</button>
      <button class="btn btn-primary w-100 w-sm-auto ms-sm-3" type="submit">Trimite</button>
    </div>
  </form>
</ng-template>
